var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu',{attrs:{"config":_vm.env}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"config":_vm.env}}),_c('Footer',{attrs:{"config":_vm.env}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }